// import { Locale } from 'App/i18n' throws error we need to make a research the error
import { DomainTranslations } from 'App/i18n';
import { Locale } from 'App/i18n/enums';
import esAR from './fulfillmentOrders.es-AR.json';
import esMX from './fulfillmentOrders.es-MX.json';
import ptBR from './fulfillmentOrders.pt-BR.json';

const fulfillmentOrdersTranslations: DomainTranslations = {
  name: 'fulfillmentOrders',
  languages: {
    [Locale.ARGENTINA]: esAR,
    [Locale.MEXICO]: esMX,
    [Locale.BRAZIL]: ptBR,
  },
};

export default fulfillmentOrdersTranslations;
